// Helper Functions

/**
 * Formats a time string to display in 12-hour format with AM/PM
 * @param {string} timeString - Time in format "HH:MM" (24-hour)
 * @returns {string} Formatted time string (e.g., "7:30 AM")
 */
export const formatTimeForDisplay = (timeString) => {
  // Handle both string input like "14:30" and number input like 14
  let hour, minute;
  
  if (typeof timeString === 'string' && timeString.includes(':')) {
    // Parse "HH:MM" format
    [hour, minute] = timeString.split(':').map(part => parseInt(part, 10));
  } else {
    // Handle legacy case where only hour is provided
    hour = parseInt(timeString, 10);
    minute = 0;
  }
  
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
};

  /**
   * Generates an array of time options for dropdown menus
   * @param {number} startHour - Starting hour (24-hour format)
   * @param {number} endHour - Ending hour (24-hour format)
   * @returns {Array} Array of objects with value and label properties
   */
  export const generateHourOptions = (startHour, endHour) => {
    const options = [];
    for (let hour = startHour; hour <= endHour; hour++) {
      options.push({
        value: hour.toString().padStart(2, '0') + ':00',
        label: formatTimeForDisplay(hour)
      });
    }
    return options;
  };